<template>
    <div class="row justify-content-center">
        <div class="col-12 text-center title-loan">
            <h1>Solicitação de Empréstimo {{getTypeLoan()}}</h1>
        </div>

        <!-- FORM EMPRESTIMO COLETIVO -->
        <emprestimo-coletivo-form v-if="type == 'EMPCOL'" :type="type"/>
        <!-- :::::::::::::::::: -->


        <!-- FORM EMPRESTIMO Impacto -->
        <emprestimo-coletivo-form v-if="type == 'EMPIMP2'" :type="type"/>
        <!-- :::::::::::::::::: -->


        <!-- FORM EMPRESTIMO Social -->
        <emprestimo-impacto-form v-if="type == 'EMPSOC'" :type="type" :changeType="changeType"/>
        <!-- ::::::::::::::::::::: -->
    </div>
</template>

<script>
import EmprestimoColetivoForm from "@/components/loansForms/EmprestimoColetivoForm"
import EmprestimoImpactoForm from "@/components/loansForms/EmprestimoImpactoForm"

    export default {
        metaInfo: {
            htmlAttrs: {
                lang: 'pt-br'
            },
            bodyAttrs: {
                class: 'solicita-emprestimo'
            }
        },
        data() {
            return {
                 type: this.$route.query.type,
            }
        },
        methods: {
            getTypeLoan() {
                let txt;

                switch(this.type) {
                    case 'EMPPES':
                        txt = 'Pessoal';
                        break;

                    case 'EMPVEI':
                        txt = 'com Garantia Veicular';
                        break;

                    case 'EMPIMP': 
                        txt = "de Impacto";
                        break;

                    case 'EMPIMP2': 
                        txt = "de Impacto";
                        break;

                    case 'EMPIMB':
                        txt = "Imobiliario";
                        break;

                     case 'EMPSOC':
                        txt = "Social";
                        break;

                    default: 
                        txt = "Coletivo";
                        break;
                }

                return txt;
            },
            changeType(type){
                this.type = type
                this.$router.push("/tipo-de-emprestimo/simulacao?type="+type)
                this.getTypeLoan()
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/tipo-de-emprestimo/solicitar-emprestimo',
                    title: 'solicitar-emprestimo',
                })
            },
        },
        components: {
            EmprestimoColetivoForm,
            EmprestimoImpactoForm
        },
        async created() {
           //tagueamento GA
            await this.taggingGA(); 
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/iouu/mixins";
    @import "../assets/styles/iouu/variables";
    .solicita-emprestimo {
        @include xs {
            select {
                height: 40px!important;
            }
        }
    }

    .title-loan {
        &{
           @include xs {
               margin-top: 6rem;
           }
        }

        h1 {
            &{
                margin-bottom: 1rem;
            }

            @include sm {
                font-size: 2rem;
            }

            @include xs {
                font-size: 1.5rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/LoanSolicitationBeta.vue